<template>
  <div class="qs-page" :class="{ 'qs-page--no-hero': !showHero }">
    <section v-if="showHero" class="qs-hero">
      <div class="container">
        <div class="hero-layout">
          <div class="hero-main">
            <h1>{{ title }}</h1>
            <p>{{ description }}</p>
            <nav v-if="showSubnav" class="qs-subnav" aria-label="Data sections">
              <router-link to="/quick-stats/league-trends" class="subnav-link">League Trends</router-link>
              <router-link to="/quick-stats/team-rankings" class="subnav-link">Team Rankings</router-link>
              <router-link to="/quick-stats/game-previews" class="subnav-link">Game Previews</router-link>
            </nav>
            <p v-if="statusMessage" class="status-message">{{ statusMessage }}</p>
          </div>
          <aside v-if="$slots['hero-right']" class="hero-right">
            <slot name="hero-right" />
          </aside>
        </div>
      </div>
    </section>

    <section class="qs-content">
      <div class="container">
        <slot />
      </div>
    </section>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  },
  statusMessage: {
    type: String,
    default: ''
  },
  showHero: {
    type: Boolean,
    default: true
  },
  showSubnav: {
    type: Boolean,
    default: true
  }
})
</script>

<style scoped>
.qs-page {
  min-height: 100vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.qs-hero {
  padding: 3rem 0 1.2rem;
}

.hero-layout {
  display: flex;
  gap: 1.25rem;
  justify-content: space-between;
  align-items: flex-start;
}

.hero-main {
  min-width: 0;
}

.hero-right {
  width: min(360px, 42%);
  flex-shrink: 0;
}

.qs-hero h1 {
  font-size: clamp(2rem, 4vw, 3rem);
  margin-bottom: 0.6rem;
}

.qs-hero p {
  max-width: 760px;
}

.qs-subnav {
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.subnav-link {
  text-decoration: none;
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 0.36rem 0.8rem;
  font-size: 0.86rem;
  color: var(--text-secondary);
}

.subnav-link.router-link-active {
  color: #fff;
  border-color: var(--accent);
  background: var(--accent);
  box-shadow: 0 8px 18px rgba(91, 124, 255, 0.24);
}

.status-message {
  margin-top: 0.9rem;
  padding: 0.75rem 0.9rem;
  border-radius: 12px;
  border: 1px solid rgba(248, 113, 113, 0.3);
  background: rgba(127, 29, 29, 0.2);
  color: #fecaca;
  font-size: 0.9rem;
}

.qs-content {
  padding-bottom: 3.5rem;
}

.qs-page > .qs-content:first-child {
  padding-top: 6.8rem;
}

.qs-page--no-hero > .qs-content:first-child {
  padding-top: clamp(1rem, 1.8vw, 1.35rem);
}

@media (max-width: 900px) {
  .hero-layout {
    flex-direction: column;
  }

  .hero-right {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .container {
    padding: 0 1rem;
  }

  .qs-hero {
    padding-top: 2.2rem;
  }

  .qs-page > .qs-content:first-child {
    padding-top: 5.4rem;
  }

  .qs-page--no-hero > .qs-content:first-child {
    padding-top: 0.9rem;
  }
}
</style>
